module.exports = __webpack_public_path__ + "4be1bbf3d1af1cd6e1939cddab7f60bc.pdf";